import type {Mapper} from 'framework';
import type {Product} from '../../domain/product';
import type {ProductDto} from '../dto/product.dto';

export class ProductDtoToProductMapper implements Mapper<ProductDto, Product> {
  transform(dto: ProductDto): Product {
    return {
      id: dto.id,
      barcode: dto.barcode,
      fdcId: dto.fdcId,
      source: dto.source,
      name: dto.name,
      brand: dto.brand,
      label: dto.label ?? null,
      kcalPer100g: dto.kcalPer100g,
      proteinPer100g: dto.proteinPer100g,
      carbsPer100g: dto.carbsPer100g,
      fatPer100g: dto.fatPer100g,
      serving: dto.serving === null ? null : {unit: dto.serving.unit, grams: dto.serving.grams},
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt,
    };
  }
}
